import { useEffect, RefObject } from "react";

export const useClickOutside = (
  ref: RefObject<HTMLElement | null>,
  callback: () => void,
  ignoredElements?: string[]
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const isOverlayClick =
        target?.className?.includes?.("quill-ui-next-overlay") ?? false;
      const isInsideOverlay =
        target?.closest(".quill-ui-next-overlay") !== null;

      if (
        ref.current &&
        !ref.current.contains(target) &&
        !isOverlayClick &&
        !isInsideOverlay &&
        !ignoredElements?.some((element) => {
          if (target?.className?.includes?.(element)) return true;
          if (typeof target?.closest === 'function') {
            const found = target.closest(`[class*="${element}"]`);
            if (found) return true;
          }
          return false;
        })
      ) {
        callback();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, callback]);
};
